import React from 'react';
// import Puzzle from '../../assest/puzzle.png'
import './sciqusamsservices.scss'

const SciqusAmsServices = () => {
	
	const services = [
		{
			title: "Onboarding",
			desc: "Smooth onboarding to align Sciqus AMS with your customer success goals and business context."
		},
		{
			title: "Workshop",
			desc: "Collaborative workshops to understand customer journeys, success metrics, and account priorities."
		},
		{
			title: "Configuration",
			desc: "Configure Sciqus AMS workflows, dashboards, and AI signals to match your operational needs."
		},
		{
			title: "Integration",
			desc: "Seamless integration with existing systems to enable unified, real-time customer visibility."
		},
		{
			title: "Data Migration",
			desc: "Secure migration of historical customer and account data to ensure continuity and accuracy."
		},
		{
			title: "Training",
			desc: "Hands-on training to equip teams with the skills to use Sciqus AMS effectively and confidently.\n"
		}
	];
	
	return (
		<section id="services" className="services-section">
			<h2 className="services-title">Our SciqusAMS Services</h2>
			
			<div className="sub-services-wrapper">
				<div className="services-wrapper">
					{services.map ((service, index) => (
						<div className="service-card" key={index}>
							<h4>{service.title}:</h4>
							<p>{service.desc}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default SciqusAmsServices;